// import { observer } from 'mobx-react-lite';
// import React from 'react';
// import { FormattedMessage, useIntl } from 'react-intl';

// import useContentPage from '../hooks/useContentPage';

// import ContentPageWrapper from '../components/ContentPageWrapper';
// import Title from '../components/Title';
// import Layout from '../components/Layout';
// import SEO from '../components/SEO';

// const PrivacyPolicy = ({ uri }) => {
//   const intl = useIntl();
//   const { markup } = useContentPage({ page: 'privacy_policy' });

//   return (
//     <Layout alwaysRaisedHeader uri={uri}>
//       <SEO title={intl.formatMessage({ defaultMessage: 'Privacy Policy' })} />
//       <ContentPageWrapper>
//         <Title>
//           <FormattedMessage defaultMessage="Privacy Policy" />
//         </Title>
//         <div dangerouslySetInnerHTML={{ __html: markup }} />
//       </ContentPageWrapper>
//     </Layout>
//   );
// };

// export default observer(PrivacyPolicy);

import React from 'react';
import Redirect from '../components/Redirect';

const IndexPage = () => {
  return <Redirect to="https://www.stk-workshop.com/" includeQuery />;
  // return <Redirect to="/r2d2" includeQuery />;
};

export default IndexPage;
